import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { notificationService } from "@/api/notification";

export const useNotifications = (params?: { page?: number; limit?: number }) => {
  return useQuery({
    queryKey: ["notifications", params],
    queryFn: () => notificationService.list(params),
    // Polling for new notifications every 1 minute
    refetchInterval: 60000,
  });
};

export const useMarkNotificationRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => notificationService.markAsRead(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
};

export const useSetFcmToken = () => {
  return useMutation({
    mutationFn: (data: { device_token: string }) =>
      notificationService.setFcmToken(data),
  });
};
